/**
 * Returns true or false depending if the app is a lounge portal app
 * uses the current browser url
 */
export const isLoungePortal = (): boolean => {
  if(!window) return false
  const path = window.location.pathname;
  return path.split('/').filter(Boolean)[0]  === 'lounge-portal';
};
